import { CalendarParams, formatValue, Holiday, validBusinessDay } from '../at-date-picker'
import { useEffect, useState } from 'react'
import { usePopper } from 'react-popper'
import { Pill } from './pill'
import { CalendarDialog } from '../at-date-picker/calendar'

export type AtPillCalendarProps = CalendarParams & {
  id?: string
  label: string
  disabled?: boolean
  open?: boolean
  onClick?: (open: boolean) => void
  holidays?: Holiday
}

export const AtPillCalendar = ({
  id,
  label,
  mode = 'single',
  onChange,
  value,
  disabled,
  open = false,
  onClick,
  holidays,
}: AtPillCalendarProps) => {
  const [button, setButton] = useState<HTMLButtonElement | null>(null)
  const [calendar, setCalendar] = useState<HTMLDivElement | null>(null)
  const [size, setSize] = useState<'small' | 'medium'>('small')
  useEffect(() => {
    const boundary = window.matchMedia('(min-width: 1440px)')
    const sizeChange = () => setSize(window.visualViewport && window.visualViewport.width >= 1440 ? 'small' : 'medium')

    boundary.addEventListener('change', sizeChange)
    return () => boundary.removeEventListener('change', sizeChange)
  }, [])
  const calendarPlacement = size === 'small' ? 'top-start' : 'bottom-start'
  const { attributes, styles } = usePopper(button, calendar, { placement: calendarPlacement, strategy: 'fixed' })
  const iosAdjustmentClass =
    value && 'from' in value && value?.from ? ('to' in value && value?.to ? 'min-w-[11rem]' : 'min-w-[7.5rem]') : ''
  return (
    <div id={id} className={`${iosAdjustmentClass}`}>
      <button
        ref={setButton}
        onClick={() => onClick?.(true)}
        className="group focus:outline-none focus-visible:outline focus-visible:outline-1 focus-visible:outline-neutrals-900 outline-offset-4"
        disabled={disabled}
      >
        <Pill label={label} value={formatValue(mode, value)} open={open} disabled={disabled} />
      </button>
      <CalendarDialog
        id={id ? `${id}-dialog` : undefined}
        ref={setCalendar}
        styles={styles}
        open={open}
        fromDate={validBusinessDay(new Date(), holidays)}
        onClose={() => onClick?.(false)}
        selected={value}
        onSelect={onChange}
        mode={mode}
        attributes={attributes}
        holidays={holidays}
      />
    </div>
  )
}
